module.exports = __webpack_public_path__ + "static/media/cover-tablet-738x57.c7a9fede.jpg";